export const Star = ({ className = "", size = 16, color = "var(--gold)" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M12 2 L14.2 9.8 L22 12 L14.2 14.2 L12 22 L9.8 14.2 L2 12 L9.8 9.8 Z" fill={color} />
  </svg>
);

export const Logo = ({ size = 38 }) => (
  <span
    className="inline-flex items-center justify-center rounded-full border shrink-0"
    style={{ width: size, height: size, borderColor: "var(--gold)", background: "var(--surface)" }}
  >
    <Star size={size * 0.5} />
  </span>
);

export const Wordmark = ({ className = "" }) => (
  <span className={`uppercase font-medium ${className}`} style={{ letterSpacing: "0.15em", fontFamily: "'DM Sans', sans-serif" }}>
    Mira Mirror
  </span>
);
